export default __webpack_public_path__ + "static/media/enable-cam-mac-system.fb4298c3.png";